export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY ?? "";
export const HOSTNAME = process.env.REACT_APP_HOSTNAME ?? "";
